/**
 * SwiperJS -- https://swiperjs.com/get-started
 */

import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

export default function() {
    // init the swiper
    const newSwiper = sliderElm =>  {
        let sliderData = JSON.parse(sliderElm.dataset.swiper);
        const sectionSelector = '#' + sliderElm.closest('section').id;
        const nextSelector = sectionSelector + ' .swiper-button-next';
        const prevSelector = sectionSelector + ' .swiper-button-prev';
        const nextLabel = document.querySelector(nextSelector)?.getAttribute('aria-label');
        const prevLabel = document.querySelector(prevSelector)?.getAttribute('aria-label');

        const swiper = new Swiper(sliderElm, {
            grid: sliderData.grid,
            autoplay: sliderData.autoplay,
            breakpoints: sliderData.breakpoints,
            slidesPerView: sliderData.slidesPerView,
            spaceBetween: sliderData.spaceBetween,
            loop: sliderData.loop,
            navigation: {
                //use section ids for correct slider association
                nextEl: nextSelector,
                prevEl: prevSelector,
            },
            a11y: {
                ...(nextLabel && { nextSlideMessage: nextLabel }),
                ...(prevLabel && { prevSlideMessage: prevLabel }),
            },
        });
    }

    const sliders = document.querySelectorAll('.slider');
    sliders.forEach(slider => newSwiper(slider));
}
